<ng-container>
  <hr class="mt-0 mb-0" />
  <div class="transaction-list-footer-container" [ngClass]="{ 'mod-no-pid': PID.length <= 1 }">
    @if (PID.length > 1) {
      <div class="transaction-list-footer-pid-wrapper">
        <span class="transaction-list-footer-pid">{{ "PID:" }}</span>
        <span class="color-text">{{ PID }}</span>
        @if (isVoucherTx()) {
          <div>
            <span class="transaction-list-footer-pid">{{ "voucher_tx_item_footer" | translate }}</span>
            {{ transaction?.getTrade().getBitpandatogoSerialNumber() }}
          </div>
        }
      </div>
    }
    <div class="transaction-buttons-container">
      @if (showFooterButtonWithdrawOrTradable()) {
        @if (showShareButton && transaction.canBeShared()) {
          <share-button
            class="btn-transaction"
            [transaction]="transaction"
          [isFooterBtn]="true"></share-button>
        }
        @if (getTradeType() !== 'deposit') {
          <button
            class="btn btn-primary btn-transaction"
            [ngClass]="{ disabled: disableActionButton(getTradeType()) }"
					[bp-tooltip]="
						getToolTip(getTradeType())
							| translate
								: [
										amountForButton(getTradeType())
											| tradable_precision_symbol
												: {
														id: tradable?.getId(),
														ignorePrecision: true,
														txPrecision: true,
														currencies: [tradable]
												  }
								  ]
					"
          position="top"
          (click)="tradeMore(getTradeType())"
          [tabIndex]="0">
          <span>{{ buttonLabel | translate }}</span>
        </button>
      }
    }
    @if (showFooterButtonNOTWithdrawOrTradable()) {
      @if (showShareButton && transaction.canBeShared()) {
        <share-button
          class="btn-transaction"
          [transaction]="transaction"
        [isFooterBtn]="true"></share-button>
      }
      @if (!isDigiAsset) {
        <button
          class="btn btn-primary btn-transaction"
          [ngClass]="{ disabled: disableActionButton(getTradeType()) }"
						[bp-tooltip]="
							getToolTip(getTradeType())
								| translate
									: [
											amountForButton(getTradeType())
												| fiat_precision_symbol
													: {
															id: getTransactionFiat()?.getId(),
															currencies: [getTransactionFiat()]
													  }
									  ]
						"
        position="top"
        (click)="tradeMore(getTradeType())"
        [tabIndex]="0">
        <span>{{ buttonLabel | translate }}</span>
      </button>
    }
  }
</div>
</div>
</ng-container>
